// import React, { useState } from "react";
// import {
//   X,
//   MapPin,
//   User,
//   Phone,
//   Home,
//   Building2,
//   Plus,
//   Loader2,
// } from "lucide-react";

// const AddAddressModal = ({ isOpen, onClose, onAddressAdded }) => {
//   const [formData, setFormData] = useState({
//     fullName: "",
//     phone: "",
//     addressLine1: "",
//     addressLine2: "",
//     city: "",
//     state: "",
//     postalCode: "",
//     country: "",
//     landmark: "",
//     addressType: "Home",
//     isDefault: false,
//   });

//   const [loading, setLoading] = useState(false);
//   const [errors, setErrors] = useState({});

//   const addressTypes = [
//     { value: "Home", label: "Home", icon: Home },
//     { value: "Work", label: "Work", icon: Building2 },
//     { value: "Other", label: "Other", icon: MapPin },
//   ];

//   const handleInputChange = (e) => {
//     const { name, value, type, checked } = e.target;
//     setFormData((prev) => ({
//       ...prev,
//       [name]: type === "checkbox" ? checked : value,
//     }));

//     if (errors[name]) {
//       setErrors((prev) => ({
//         ...prev,
//         [name]: "",
//       }));
//     }
//   };

//   const validateForm = () => {
//     const newErrors = {};

//     if (!formData.fullName.trim()) newErrors.fullName = "Full name is required";
//     if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
//     if (!formData.addressLine1.trim())
//       newErrors.addressLine1 = "Address line 1 is required";
//     if (!formData.city.trim()) newErrors.city = "City is required";
//     if (!formData.state.trim()) newErrors.state = "State is required";
//     if (!formData.postalCode.trim())
//       newErrors.postalCode = "Postal code is required";
//     if (!formData.country.trim()) newErrors.country = "Country is required";

//     if (formData.phone && !/^\+?[\d\s-()]{10,}$/.test(formData.phone)) {
//       newErrors.phone = "Please enter a valid phone number";
//     }

//     if (formData.postalCode && !/^\d{5,6}$/.test(formData.postalCode)) {
//       newErrors.postalCode = "Please enter a valid postal code";
//     }

//     setErrors(newErrors);
//     return Object.keys(newErrors).length === 0;
//   };

//   const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!validateForm()) return;

//     setLoading(true);

//     try {
//       const userData = localStorage.getItem("pm-user-data");
//       const user = userData ? JSON.parse(userData) : null;

//       if (!user || !user._id) {
//         throw new Error("User not found. Please log in again.");
//       }

//       const addressData = {
//         ...formData,
//         user: user._id,
//       };

//       console.log("Sending address data:", addressData);

//       const response = await fetch(
//         `${process.env.REACT_APP_API_URL}/address/create-address`,
//         {
//           method: "POST",
//           headers: {
//             "Content-Type": "application/json",
//           },
//           body: JSON.stringify(addressData),
//         }
//       );

//       console.log("Response status:", response.status);

//       if (!response.ok) {
//         const errorText = await response.text();
//         console.error("Error response:", errorText);
//         throw new Error(`Failed to create address: ${response.status}`);
//       }

//       const data = await response.json();
//       console.log("Response data:", data);

//       if (data.success) {
//         // Reset form
//         setFormData({
//           fullName: "",
//           phone: "",
//           addressLine1: "",
//           addressLine2: "",
//           city: "",
//           state: "",
//           postalCode: "",
//           country: "",
//           landmark: "",
//           addressType: "Home",
//           isDefault: false,
//         });

//         if (onAddressAdded) {
//           onAddressAdded(data.data);
//         }

//         onClose();
//       } else {
//         throw new Error(data.message || "Failed to create address");
//       }
//     } catch (error) {
//       console.error("Error creating address:", error);
//       setErrors({
//         submit: error.message || "Failed to create address. Please try again.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   const handleClose = () => {
//     if (!loading) {
//       setFormData({
//         fullName: "",
//         phone: "",
//         addressLine1: "",
//         addressLine2: "",
//         city: "",
//         state: "",
//         postalCode: "",
//         country: "",
//         landmark: "",
//         addressType: "Home",
//         isDefault: false,
//       });
//       setErrors({});
//       onClose();
//     }
//   };

//   if (!isOpen) return null;

//   return (
//     <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
//       <div className="bg-[#ecf1f5] rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
//         {/* Header */}
//         <div className="sticky top-0 z-10 bg-gradient-to-r from-[#242a30] via-[#21374e] to-[#1b344e] border-b border-gray-200 px-6 py-4 rounded-t-2xl">

//           <div className="flex items-center justify-between">
//             <div className="flex items-center gap-3">
//               <div className="p-2 bg-blue-50 rounded-lg">
//                 <Home className="text-blue-600" size={20} />
//               </div>
//               <h2 className="text-xl font-bold font-philosopher text-white">
//                 Add New Address
//               </h2>
//             </div>
//             <button
//               onClick={handleClose}
//               disabled={loading}
//               className="transition-colors disabled:opacity-50"
//             >
//               <X size={20} className="text-white" />
//             </button>
//           </div>
//         </div>

//         <form onSubmit={handleSubmit} className="p-6 space-y-6">


//           <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Full Name *
//               </label>
//               <div className="relative">
//                 <User
//                   className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
//                   size={18}
//                 />
//                 <input
//                   type="text"
//                   name="fullName"
//                   value={formData.fullName}
//                   onChange={handleInputChange}
//                   className={`w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.fullName ? "border-red-300" : "border-gray-300"
//                     }`}
//                   placeholder="Enter your full name"
//                 />
//               </div>
//               {errors.fullName && (
//                 <p className="mt-1 text-sm text-red-600">{errors.fullName}</p>
//               )}
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Phone Number *
//               </label>
//               <div className="relative">
//                 <Phone
//                   className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
//                   size={18}
//                 />
//                 <input
//                   type="tel"
//                   name="phone"
//                   value={formData.phone}
//                   onChange={handleInputChange}
//                   className={`w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.phone ? "border-red-300" : "border-gray-300"
//                     }`}
//                   placeholder="1234567890"
//                 />
//               </div>
//               {errors.phone && (
//                 <p className="mt-1 text-sm text-red-600">{errors.phone}</p>
//               )}
//             </div>
//           </div>

//           <div className="space-y-4">
//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Address Line 1 *
//               </label>
//               <input
//                 type="text"
//                 name="addressLine1"
//                 value={formData.addressLine1}
//                 onChange={handleInputChange}
//                 className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.addressLine1 ? "border-red-300" : "border-gray-300"
//                   }`}
//                 placeholder="Street address, P.O. box, company name, c/o"
//               />
//               {errors.addressLine1 && (
//                 <p className="mt-1 text-sm text-red-600">
//                   {errors.addressLine1}
//                 </p>
//               )}
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Address Line 2
//               </label>
//               <input
//                 type="text"
//                 name="addressLine2"
//                 value={formData.addressLine2}
//                 onChange={handleInputChange}
//                 className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                 placeholder="Apartment, suite, unit, building, floor, etc."
//               />
//             </div>

//             <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   City *
//                 </label>
//                 <input
//                   type="text"
//                   name="city"
//                   value={formData.city}
//                   onChange={handleInputChange}
//                   className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.city ? "border-red-300" : "border-gray-300"
//                     }`}
//                   placeholder="City"
//                 />
//                 {errors.city && (
//                   <p className="mt-1 text-sm text-red-600">{errors.city}</p>
//                 )}
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   State *
//                 </label>
//                 <input
//                   type="text"
//                   name="state"
//                   value={formData.state}
//                   onChange={handleInputChange}
//                   className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.state ? "border-red-300" : "border-gray-300"
//                     }`}
//                   placeholder="State"
//                 />
//                 {errors.state && (
//                   <p className="mt-1 text-sm text-red-600">{errors.state}</p>
//                 )}
//               </div>

//               <div>
//                 <label className="block text-sm font-medium text-gray-700 mb-2">
//                   Postal Code *
//                 </label>
//                 <input
//                   type="text"
//                   name="postalCode"
//                   value={formData.postalCode}
//                   onChange={handleInputChange}
//                   className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.postalCode ? "border-red-300" : "border-gray-300"
//                     }`}
//                   placeholder="12345"
//                 />
//                 {errors.postalCode && (
//                   <p className="mt-1 text-sm text-red-600">
//                     {errors.postalCode}
//                   </p>
//                 )}
//               </div>
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Country *
//               </label>
//               <input
//                 type="text"
//                 name="country"
//                 value={formData.country}
//                 onChange={handleInputChange}
//                 className={`w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent ${errors.country ? "border-red-300" : "border-gray-300"
//                   }`}
//                 placeholder="Country"
//               />
//               {errors.country && (
//                 <p className="mt-1 text-sm text-red-600">{errors.country}</p>
//               )}
//             </div>

//             <div>
//               <label className="block text-sm font-medium text-gray-700 mb-2">
//                 Landmark (Optional)
//               </label>
//               <div className="relative">
//                 <MapPin
//                   className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400"
//                   size={18}
//                 />
//                 <input
//                   type="text"
//                   name="landmark"
//                   value={formData.landmark}
//                   onChange={handleInputChange}
//                   className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
//                   placeholder="Near Central Park, Behind Mall, etc."
//                 />
//               </div>
//             </div>
//           </div>

//           <div className="flex items-center gap-3">
//             <input
//               type="checkbox"
//               id="isDefault"
//               name="isDefault"
//               checked={formData.isDefault}
//               onChange={handleInputChange}
//               className="w-5 h-5 text-blue-600 bg-gray-100 border-gray-300 rounded focus:ring-blue-500"
//             />
//             <label
//               htmlFor="isDefault"
//               className="text-sm font-medium text-gray-700"
//             >
//               Make this my default address
//             </label>
//           </div>
//           <div>
//             <label className="block text-sm font-medium text-gray-700 mb-3">
//               Address Type
//             </label>
//             <div className="grid grid-cols-4 gap-3">
//               {addressTypes.map((type) => {
//                 const IconComponent = type.icon;
//                 return (
//                   <button
//                     key={type.value}
//                     type="button"
//                     onClick={() =>
//                       setFormData((prev) => ({
//                         ...prev,
//                         addressType: type.value,
//                       }))
//                     }
//                     className={`p-2 rounded-lg border-2 transition-all ${formData.addressType === type.value
//                       ? "border-blue-500 bg-blue-50"
//                       : "border-gray-200 hover:border-gray-300"
//                       }`}
//                   >
//                     <IconComponent
//                       size={24}
//                       className={`mx-auto mb-2 ${formData.addressType === type.value
//                         ? "text-blue-600"
//                         : "text-gray-400"
//                         }`}
//                     />
//                     <p
//                       className={`text-sm font-medium ${formData.addressType === type.value
//                         ? "text-blue-600"
//                         : "text-gray-700"
//                         }`}
//                     >
//                       {type.label}
//                     </p>
//                   </button>
//                 );
//               })}
//             </div>
//           </div>
//           <div className="flex gap-3 pt-6 border-t border-gray-200">
//             <button
//               type="button"
//               onClick={handleClose}
//               disabled={loading}
//               className="flex-1 px-6 py-3  border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 font-medium transition-colors disabled:opacity-50"
//             >
//               Cancel
//             </button>
//             <button
//               type="submit"
//               disabled={loading}
//               className="flex-1 text-[0.9rem] justify-center p-2 bg-gradient-to-r from-[#4a72f5] to-[#266bd2] hover:from-[#3c6fe6] hover:to-[#1d43d9] text-white rounded-lg font-medium shadow-lg hover:shadow-xl transition-all duration-300 disabled:opacity-50 disabled:cursor-not-allowed flex items-center"
//             >
//               {loading ? (
//                 <>
//                   <Loader2 size={18} className="animate-spin" />
//                   Adding Address...
//                 </>
//               ) : (
//                 <>
//                   <Plus size={18} />
//                   Add Address
//                 </>
//               )}
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default AddAddressModal;


import React, { useState } from "react";
import {
  X,
  MapPin,
  User,
  Phone,
  Home,
  Building2,
  Plus,
  Loader2,
  Navigation,
} from "lucide-react";

const GOOGLE_MAPS_API_KEY = process.env.REACT_APP_GOOGLE_MAPS_API_KEY;

const AddAddressModal = ({ isOpen, onClose, onAddressAdded }) => {
  const [formData, setFormData] = useState({
    fullName: "",
    phone: "",
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    postalCode: "",
    country: "",
    landmark: "",
    addressType: "Home",
    isDefault: false,
  });

  const [loading, setLoading] = useState(false);
  const [locationLoading, setLocationLoading] = useState(false);
  const [locationError, setLocationError] = useState("");
  const [errors, setErrors] = useState({});

  const addressTypes = [
    { value: "Home", label: "Home", icon: Home },
    { value: "Work", label: "Work", icon: Building2 },
    { value: "Other", label: "Other", icon: MapPin },
  ];

  // ── Google Maps Geocoding: coords → address fields ──────────────
  const parseGeoResults = (results) => {
    const get = (type) => {
      const comp = results[0].address_components.find((c) =>
        c.types.includes(type)
      );
      return comp ? comp.long_name : "";
    };
    const getShort = (type) => {
      const comp = results[0].address_components.find((c) =>
        c.types.includes(type)
      );
      return comp ? comp.short_name : "";
    };

    const streetNumber = get("street_number");
    const route = get("route");
    const sublocality = get("sublocality_level_1") || get("sublocality");
    const addressLine1 = [streetNumber, route, sublocality]
      .filter(Boolean)
      .join(", ");

    return {
      addressLine1: addressLine1 || get("premise") || "",
      city:
        get("locality") ||
        get("administrative_area_level_2") ||
        get("postal_town") ||
        "",
      state: get("administrative_area_level_1") || "",
      postalCode: get("postal_code") || "",
      country: get("country") || "",
    };
  };

  const handleUseCurrentLocation = () => {
    setLocationError("");

    if (!navigator.geolocation) {
      setLocationError("Geolocation is not supported by your browser.");
      return;
    }

    setLocationLoading(true);

    navigator.geolocation.getCurrentPosition(
      async ({ coords: { latitude, longitude } }) => {
        try {
          const res = await fetch(
            `https://maps.googleapis.com/maps/api/geocode/json?latlng=${latitude},${longitude}&key=${GOOGLE_MAPS_API_KEY}`
          );
          const data = await res.json();

          if (data.status === "OK" && data.results.length > 0) {
            const parsed = parseGeoResults(data.results);
            setFormData((prev) => ({
              ...prev,
              ...parsed,
            }));
            // Clear related errors
            setErrors((prev) => ({
              ...prev,
              addressLine1: "",
              city: "",
              state: "",
              postalCode: "",
              country: "",
            }));
          } else {
            setLocationError(
              "Could not fetch address from coordinates. Please fill manually."
            );
          }
        } catch {
          setLocationError("Failed to call Google Maps API. Check your API key.");
        } finally {
          setLocationLoading(false);
        }
      },
      (err) => {
        setLocationLoading(false);
        if (err.code === err.PERMISSION_DENIED) {
          setLocationError(
            "Location permission denied. Please allow location access in your browser settings."
          );
        } else {
          setLocationError("Unable to retrieve your location. Try again.");
        }
      },
      { timeout: 10000, enableHighAccuracy: true }
    );
  };

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: "" }));
    }
  };

  const validateForm = () => {
    const newErrors = {};
    if (!formData.fullName.trim()) newErrors.fullName = "Full name is required";
    if (!formData.phone.trim()) newErrors.phone = "Phone number is required";
    if (!formData.addressLine1.trim())
      newErrors.addressLine1 = "Address line 1 is required";
    if (!formData.city.trim()) newErrors.city = "City is required";
    if (!formData.state.trim()) newErrors.state = "State is required";
    if (!formData.postalCode.trim())
      newErrors.postalCode = "Postal code is required";
    if (!formData.country.trim()) newErrors.country = "Country is required";
    if (formData.phone && !/^\+?[\d\s-()]{10,}$/.test(formData.phone))
      newErrors.phone = "Please enter a valid phone number";
    if (formData.postalCode && !/^\d{4,10}$/.test(formData.postalCode))
      newErrors.postalCode = "Please enter a valid postal code";
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!validateForm()) return;
    setLoading(true);
    try {
      const userData = localStorage.getItem("pm-user-data");
      const user = userData ? JSON.parse(userData) : null;
      if (!user || !user._id) throw new Error("User not found. Please log in again.");

      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/address/create-address`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ ...formData, user: user._id }),
        }
      );
      if (!response.ok) throw new Error(`Failed to create address: ${response.status}`);
      const data = await response.json();
      if (data.success) {
        setFormData({
          fullName: "", phone: "", addressLine1: "", addressLine2: "",
          city: "", state: "", postalCode: "", country: "",
          landmark: "", addressType: "Home", isDefault: false,
        });
        if (onAddressAdded) onAddressAdded(data.data);
        onClose();
      } else {
        throw new Error(data.message || "Failed to create address");
      }
    } catch (error) {
      setErrors({ submit: error.message || "Failed to create address. Please try again." });
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (!loading) {
      setFormData({
        fullName: "", phone: "", addressLine1: "", addressLine2: "",
        city: "", state: "", postalCode: "", country: "",
        landmark: "", addressType: "Home", isDefault: false,
      });
      setErrors({});
      setLocationError("");
      onClose();
    }
  };

  if (!isOpen) return null;

  const inputCls = (field) =>
    `w-full px-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent transition-all bg-white ${
      errors[field] ? "border-red-300 bg-red-50" : "border-gray-300"
    }`;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-[9999] p-4">
      <div className="bg-[#ecf1f5] rounded-2xl shadow-2xl w-full max-w-2xl max-h-[90vh] overflow-y-auto">
        {/* Header */}
        <div className="sticky top-0 z-10 bg-gradient-to-r from-[#242a30] via-[#21374e] to-[#1b344e] border-b border-gray-200 px-6 py-4 rounded-t-2xl">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-3">
              <div className="p-2 bg-blue-50 rounded-lg">
                <Home className="text-blue-600" size={20} />
              </div>
              <h2 className="text-xl font-bold font-philosopher text-white">
                Add New Address
              </h2>
            </div>
            <button onClick={handleClose} disabled={loading}>
              <X size={20} className="text-white" />
            </button>
          </div>
        </div>

        <form onSubmit={handleSubmit} className="p-6 space-y-5">
          {/* Error banner */}
          {errors.submit && (
            <div className="bg-red-50 border border-red-200 rounded-lg p-4">
              <p className="text-red-600 text-sm">{errors.submit}</p>
            </div>
          )}

          {/* ── Use Current Location Button ───────────────────── */}
          <div className="flex flex-col gap-2">
            <button
              type="button"
              onClick={handleUseCurrentLocation}
              disabled={locationLoading}
              className="flex items-center justify-center gap-2 w-full py-3 px-4 rounded-xl border-2 border-dashed border-[#00395F]/40 bg-[#00395F]/5 hover:bg-[#00395F]/10 hover:border-[#00395F]/60 text-[#00395F] font-semibold text-sm transition-all disabled:opacity-60 disabled:cursor-not-allowed"
            >
              {locationLoading ? (
                <>
                  <Loader2 size={18} className="animate-spin" />
                  Fetching your location...
                </>
              ) : (
                <>
                  <Navigation size={18} />
                  Use Current Location
                </>
              )}
            </button>
            {locationError && (
              <p className="text-xs text-red-500 text-center">{locationError}</p>
            )}
            {!locationError && !locationLoading && formData.city && (
              <p className="text-xs text-green-600 text-center flex items-center justify-center gap-1">
                <MapPin size={12} />
                Location auto-filled — review and adjust if needed
              </p>
            )}
          </div>

          <div className="flex items-center gap-3">
            <div className="flex-1 h-px bg-gray-300" />
            <span className="text-xs text-gray-400 font-medium">OR FILL MANUALLY</span>
            <div className="flex-1 h-px bg-gray-300" />
          </div>

          {/* Full Name + Phone */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Full Name <span className="text-red-400">*</span>
              </label>
              <div className="relative">
                <User className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                <input
                  type="text"
                  name="fullName"
                  value={formData.fullName}
                  onChange={handleInputChange}
                  className={`w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white ${
                    errors.fullName ? "border-red-300 bg-red-50" : "border-gray-300"
                  }`}
                  placeholder="Enter your full name"
                />
              </div>
              {errors.fullName && <p className="mt-1 text-xs text-red-600">{errors.fullName}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Phone Number <span className="text-red-400">*</span>
              </label>
              <div className="relative">
                <Phone className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={handleInputChange}
                  className={`w-full pl-10 pr-4 py-3 border rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white ${
                    errors.phone ? "border-red-300 bg-red-50" : "border-gray-300"
                  }`}
                  placeholder="1234567890"
                />
              </div>
              {errors.phone && <p className="mt-1 text-xs text-red-600">{errors.phone}</p>}
            </div>
          </div>

          {/* Address Fields */}
          <div className="space-y-4">
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Address Line 1 <span className="text-red-400">*</span>
              </label>
              <input
                type="text"
                name="addressLine1"
                value={formData.addressLine1}
                onChange={handleInputChange}
                className={inputCls("addressLine1")}
                placeholder="Street address, P.O. box, company name"
              />
              {errors.addressLine1 && <p className="mt-1 text-xs text-red-600">{errors.addressLine1}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Address Line 2 <span className="text-gray-400 font-normal text-xs">(Optional)</span>
              </label>
              <input
                type="text"
                name="addressLine2"
                value={formData.addressLine2}
                onChange={handleInputChange}
                className="w-full px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                placeholder="Apartment, suite, unit, floor, etc."
              />
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  City <span className="text-red-400">*</span>
                </label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleInputChange}
                  className={inputCls("city")}
                  placeholder="City"
                />
                {errors.city && <p className="mt-1 text-xs text-red-600">{errors.city}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  State <span className="text-red-400">*</span>
                </label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleInputChange}
                  className={inputCls("state")}
                  placeholder="State"
                />
                {errors.state && <p className="mt-1 text-xs text-red-600">{errors.state}</p>}
              </div>

              <div>
                <label className="block text-sm font-medium text-gray-700 mb-2">
                  Postal Code <span className="text-red-400">*</span>
                </label>
                <input
                  type="text"
                  name="postalCode"
                  value={formData.postalCode}
                  onChange={handleInputChange}
                  className={inputCls("postalCode")}
                  placeholder="12345"
                  inputMode="numeric"
                />
                {errors.postalCode && <p className="mt-1 text-xs text-red-600">{errors.postalCode}</p>}
              </div>
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Country <span className="text-red-400">*</span>
              </label>
              <input
                type="text"
                name="country"
                value={formData.country}
                onChange={handleInputChange}
                className={inputCls("country")}
                placeholder="Country"
              />
              {errors.country && <p className="mt-1 text-xs text-red-600">{errors.country}</p>}
            </div>

            <div>
              <label className="block text-sm font-medium text-gray-700 mb-2">
                Landmark <span className="text-gray-400 font-normal text-xs">(Optional)</span>
              </label>
              <div className="relative">
                <MapPin className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400" size={18} />
                <input
                  type="text"
                  name="landmark"
                  value={formData.landmark}
                  onChange={handleInputChange}
                  className="w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent bg-white"
                  placeholder="Near Central Park, Behind Mall, etc."
                />
              </div>
            </div>
          </div>

          {/* Address Type */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-3">
              Address Type
            </label>
            <div className="grid grid-cols-3 gap-3">
              {addressTypes.map((type) => {
                const Icon = type.icon;
                const active = formData.addressType === type.value;
                return (
                  <button
                    key={type.value}
                    type="button"
                    onClick={() => setFormData((p) => ({ ...p, addressType: type.value }))}
                    className={`p-3 rounded-xl border-2 transition-all flex flex-col items-center gap-1.5 ${
                      active
                        ? "border-[#00395F] bg-[#00395F]/5"
                        : "border-gray-200 bg-white hover:border-gray-300"
                    }`}
                  >
                    <Icon size={22} className={active ? "text-[#00395F]" : "text-gray-400"} />
                    <p className={`text-sm font-semibold ${active ? "text-[#00395F]" : "text-gray-600"}`}>
                      {type.label}
                    </p>
                  </button>
                );
              })}
            </div>
          </div>

          {/* Default checkbox */}
          <label className="flex items-center gap-3 cursor-pointer select-none">
            <input
              type="checkbox"
              name="isDefault"
              checked={formData.isDefault}
              onChange={handleInputChange}
              className="w-5 h-5 text-[#00395F] border-gray-300 rounded focus:ring-[#00395F]"
            />
            <span className="text-sm font-medium text-gray-700">
              Make this my default address
            </span>
          </label>

          {/* Actions */}
          <div className="flex gap-3 pt-4 border-t border-gray-200">
            <button
              type="button"
              onClick={handleClose}
              disabled={loading}
              className="flex-1 px-6 py-3 border border-gray-300 text-gray-700 rounded-xl hover:bg-gray-50 font-medium transition-colors disabled:opacity-50 bg-white"
            >
              Cancel
            </button>
            <button
              type="submit"
              disabled={loading}
              className="flex-1 flex items-center justify-center gap-2 py-3 bg-gradient-to-r from-[#4a72f5] to-[#266bd2] hover:from-[#3c6fe6] hover:to-[#1d43d9] text-white rounded-xl font-semibold shadow-lg hover:shadow-xl transition-all disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? (
                <><Loader2 size={18} className="animate-spin" /> Adding...</>
              ) : (
                <><Plus size={18} /> Add Address</>
              )}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default AddAddressModal;